import {
  getVisualizationInterface,
  RelationshipDiagramsSpecificInterface,
  ScopeDataParams,
} from '@ardoq/graph';
import { getRelationshipDiagramsSpecificInterface } from './relationshipDiagramsViewInterface';

export const getDefaultRelationshipDiagramsViewInterface = (
  scopeDataParams?: ScopeDataParams
) =>
  getVisualizationInterface<RelationshipDiagramsSpecificInterface>({
    scopeDataParams,
    getViewSpecificInterface: getRelationshipDiagramsSpecificInterface,
  });
